export default __webpack_public_path__ + "static/media/indonesia2018C.2ff380fa.jpg";